




























































































































































































import {
  defineComponent,
  onMounted,
  reactive,
  ref,
  watch,
} from '@vue/composition-api';
import { useRouter } from '@ideavivat/vivat-2';

import useAuth from '@/useAuth';

import documentTableOptions from '@/table/document';

import {
  createLive,
  getLive,
  updateLive,
  getDocuments,
  deleteDocuments,
} from '@/api/index';

import useAxios from '@/useAxios';

import CommonToggleButton from '@/components/CommonToggleButton.vue';
import CommonModalWithPreset from '@/components/CommonModalWithPreset.vue';
import CommonDropzoneWithAxios from '@/components/Dropzone/CommonDropzoneWithAxios.vue';

const PanelWithSessionEditor = defineComponent({
  components: {
    CommonModalWithPreset,
    CommonDropzoneWithAxios,
    CommonToggleButton,
  },
  props: {
    edit: { default() { return false; } },
  },
  setup(props: any) {
    const { route } = useRouter();
    const { axios } = useAxios();
    const { hasPermission } = useAuth();
    const NOW = new Date();

    const successModal = ref(null);
    const documentDownloadType = ref('UPLOAD');
    const documentDownloadUrl = ref('');

    const form = reactive({
      topic: '',
      topicEN: '',
      description: '',
      descriptionEN: '',
      speakers: '',
      scheduledTime: NOW,
      enableChat: true,
      enableQuestion: true,
      enablePoll: true,
      fallbackImage: '',
      fileName: '',
      titleTH: '',
      titleEN: '',
      rule: '',
      ruleEN: '',
      call: async () => {
        /* eslint-disable */
        if (props.edit === true) {
          await updateLive(route.value.params.id ,{
            topic: form.topic,
            topic_en: form.topicEN,
            description: form.description,
            description_en: form.descriptionEN,
            scheduled_time: form.scheduledTime,
            enable_chat: form.enableChat,
            enable_question: form.enableQuestion,
            enable_poll: form.enablePoll,
            fallback_image: form.fallbackImage,
            title_th: form.titleTH,
            title_en: form.titleEN,
            rule: form.rule,
            rule_en: form.ruleEN,
          })
        } else {
          await createLive({
            topic: form.topic,
            topic_en: form.topicEN,
            description: form.description,
            description_en: form.descriptionEN,
            scheduled_time: form.scheduledTime,
            enable_chat: form.enableChat,
            enable_question: form.enableQuestion,
            enable_poll: form.enablePoll,
            fallback_image: form.fallbackImage,
            title_th: form.titleTH,
            title_en: form.titleEN,
            rule: form.rule,
            rule_en: form.ruleEN,
          });
        }
        /* eslint-enable */
        (successModal.value as any).compose({ action: 'บันทึก', entity: 'ข้อมูลเรียบร้อย' });
      },
      state: {
        value: 'READY',
      },
    });

    const files = ref({});
    const filesLoading = ref(true);
    const sort = ref({ field: 'file_name', order: 'DESC' });
    const pagination = ref({
      // eslint-disable-next-line
      current_page: 1,
    });
    const handleSortChange = (sortParam: { field: string; order: string }) => {
      sort.value = sortParam;
    };
    async function callGetDocuments() {
      filesLoading.value = true;
      const { data, ...paginatorData } = await getDocuments(
        route.value.params.id,
        sort.value,
      );
      files.value = data;
      pagination.value = paginatorData;
      filesLoading.value = false;
    }
    watch(() => sort.value, async (newVal, oldVal) => {
      // eslint-disable-next-line
      if (newVal !== oldVal) {
        await callGetDocuments();
      }
    });

    onMounted(async () => {
      await callGetDocuments();
      if (props.edit) {
        const result = await getLive(route.value.params.id);
        form.topic = result.topic;
        form.topicEN = result.topic_en;
        form.description = result.description;
        form.descriptionEN = result.description_en;
        form.scheduledTime = result.scheduled_time;
        form.enableChat = result.enable_chat;
        form.enableQuestion = result.enable_question;
        form.enablePoll = result.enable_poll;
        form.fallbackImage = result.fallback_image;

        form.titleTH = result.title_th;
        form.titleEN = result.title_en;
        form.rule = result.rule;
        form.ruleEN = result.rule_en;
      }
    });

    function handleUploadDone(data: any) {
      if (props.edit) form.fallbackImage = data.data.session.fallback_image;
      else form.fallbackImage = data.data.path;
    }

    async function handleUploadFileDone(data: any) {
      form.fileName = '';
      await callGetDocuments();
    }

    const deleteFileModal = ref(null);
    async function openDeleteFileModal(item: any) {
      (deleteFileModal.value as any).compose({
        id: item.id,
        action: 'ลบ',
        entity: 'ไฟล์',
        body: `เป็นการลบ<br>${item.file_name}<br>จากระบบโดยถาวร<br>ไม่สามารถย้อนคืนได้`,
      });
    }
    async function deleteItemAction(id: number) {
      const result = await deleteDocuments([id]);
      await callGetDocuments();
    }
    async function downloadDocument(file: any) {
      window.open(file.file_path, '_blank');
      return '';
    }

    return {
      hasPermission,
      form,
      successModal,

      files,
      filesLoading,
      pagination,
      sort,
      documentTableOptions,
      handleSortChange,

      axios,
      handleUploadDone,
      handleUploadFileDone,

      deleteFileModal,
      deleteItemAction,
      openDeleteFileModal,
      downloadDocument,

      documentDownloadType,
      documentDownloadUrl,
    };
  },
});

export default PanelWithSessionEditor;
